import { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { BASE_URL, BLACK, PRIMARY, WHITE } from "../../appConstants";
import { Button } from "@mui/joy";
import appError from "../../appError";
import axios from "axios";
import toast from "react-hot-toast";

const CategoryMasterManagement: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const data = localStorage.getItem('brand');
    const {category_hierarchy_level = 0, brand_id = ''} = data ? JSON.parse(data) : {};
    const [selectedTab, setSelectedTab] = useState<string>(category_hierarchy_level === 4 ? "PRINCIPAL_CATEGORY" : category_hierarchy_level === 3 ? "MAIN_CATEGORY" : category_hierarchy_level === 2 ? "CATEGORY" : "");

    const tabs = [ 
        { id: "PRINCIPAL_CATEGORY", name: "Principal Category", url: `/categorymaster/principal_category/${brand_id}` },
        { id: "MAIN_CATEGORY", name: "Main Category", url: `/categorymaster/main_category/${brand_id}` },
        { id: "CATEGORY", name: "Category", url: `/categorymaster/category/${brand_id}` },
        { id: "SUB_CATEGORY", name: "Sub Category", url: `/categorymaster/sub_category/${brand_id}` }
    ]

    const onTabChange = (tab: string, url: string) => {
        setSelectedTab(tab);
        navigate(url);
    }

    const [category_levels, setCategory_levels] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const onSaveHandler = async () => {
      const token = localStorage.getItem("token");
      try {
          setLoading(true);
          const headers = {
              Authorization: `Bearer ${token}`,
            };
          const res = await axios.put(
              `${BASE_URL}brand/updateCategoryHierarchyLevels?brand_id=${brand_id}&`, {category_levels: Number(category_levels)},
              {headers}
            );
  
          if(res?.data?.status === 'success'){
            const brandDataStr = localStorage.getItem('brand');

            if (brandDataStr) {
              const parsedBrand = JSON.parse(brandDataStr);

              parsedBrand.category_hierarchy_level = Number(category_levels);

              localStorage.setItem('brand', JSON.stringify(parsedBrand));

              setSelectedTab(Number(category_levels) === 4 ? "PRINCIPAL_CATEGORY" : Number(category_levels) === 3 ? "MAIN_CATEGORY" : Number(category_levels) === 2 ? "CATEGORY" : "");

              navigate(Number(category_levels) === 4 ? `/categorymaster/principal_category/${brand_id}` : Number(category_levels) === 3 ? `/categorymaster/main_category/${brand_id}` : Number(category_levels) === 2 ? `/categorymaster/category/${brand_id}` : "");

              setCategory_levels('');
            }
          }

      } catch (error) {
          appError(error);
      } finally {
          setLoading(false);
      }
    };
    
  return (
    <>
      {category_hierarchy_level === null ? (
        <div style={{ height: "calc(100vh - 72px)"}} className="flex flex-col gap-6">
          <div
          className="mt-6 mx-10 flex flex-row justify-between items-center px-6"
          style={{
            height: 96,
            borderRadius: 8,
            backgroundColor: PRIMARY.P_Purple50,
          }}
        >
            <div>
              <div
                className="mb-1"
                style={{ fontSize: 16, fontWeight: 600, lineHeight: "24px" }}
              >
                This brand has not been assigned any category levels yet.
              </div>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 400,
                  lineHeight: "18px",
                  color: BLACK.B_40,
                }}
              >
                {" "}
                Assign Category Levels & Select the Category Structure
              </div>
            </div>
          </div>

          <div style={{ height: "calc(100vh - 312px)"}} 
          className="mx-10 flex flex-col gap-6">
            <div
            style={{
              border: category_levels === "4" ? "1px solid #1886FE" : "1px solid rgba(28, 28, 28, 0.05)",
              boxShadow: "0px 4px 10px 4px rgba(130, 130, 130, 0.05)"
            }}
            className="w-[50%] rounded-[16px] p-4 flex flex-1" 
            onClick={() => setCategory_levels('4')}>
              <div className="h-full w-[20%] flex items-center justify-center">
                <input
                  type="radio"
                  name="options"
                  value="keywordmapping"
                  checked={category_levels === "4"}
                  style={{
                    width: 20,
                    height: 20,
                    accentColor: PRIMARY.P_BLue,
                    cursor: "pointer",
                  }}
                />
              </div>
              <div className="h-full w-[80%] flex flex-col justify-around">
                <div className="self-center">Four Category Structure</div>
                <div className="flex gap-4">
                    <div className="">Principal Category</div>
                    <div className="" style={{border: "1px solid #EAEAED"}}></div>
                    <div className="">Main Category</div>
                    <div className="" style={{border: "1px solid #EAEAED"}}></div>
                    <div className="">Category</div>
                    <div className="" style={{border: "1px solid #EAEAED"}}></div>
                    <div className="">Sub Category</div>
                </div>
              </div>
            </div>

            <div
            style={{
              border: category_levels === "3" ? "1px solid #1886FE" : "1px solid rgba(28, 28, 28, 0.05)",
              boxShadow: "0px 4px 10px 4px rgba(175, 149, 149, 0.05)"
            }}
            className="w-[50%] rounded-[16px] p-4 flex flex-1" 
            onClick={() => setCategory_levels('3')}>
              <div className="h-full w-[20%] flex items-center justify-center">
                <input
                  type="radio"
                  name="options"
                  value="keywordmapping"
                  checked={category_levels === "3"}
                  style={{
                    width: 20,
                    height: 20,
                    accentColor: PRIMARY.P_BLue,
                    cursor: "pointer",
                  }}
                />
              </div>
              <div className="h-full w-[80%] flex flex-col justify-around">
                <div className="self-center">Three Category Structure</div>
                <div className="flex gap-4">
                    <div className="">Main Category</div>
                    <div className="" style={{border: "1px solid #EAEAED"}}></div>
                    <div className="">Category</div>
                    <div className="" style={{border: "1px solid #EAEAED"}}></div>
                    <div className="">Sub Category</div>
                </div>
              </div>
            </div>

            <div
                style={{
                  border: category_levels === "2" ? "1px solid #1886FE" : "1px solid rgba(28, 28, 28, 0.05)",
                  boxShadow: "0px 4px 10px 4px rgba(130, 130, 130, 0.05)"
                }}
                className="w-[50%] rounded-[16px] p-4 flex flex-1" 
                onClick={() => setCategory_levels('2')}>
                <div className="h-full w-[20%] flex items-center justify-center">
                  <input
                    type="radio"
                    name="options"
                    value="keywordmapping"
                    checked={category_levels === "2"}
                    style={{
                      width:20,
                      height: 20,
                      accentColor: PRIMARY.P_BLue,
                      cursor: "pointer",
                    }}
                  />
                </div>
                <div className="h-full w-[80%] flex flex-col justify-around">
                  <div className="self-center">Two Category Structure</div>
                  <div className="flex gap-4">
                      <div className="">Category</div>
                      <div className="" style={{border: "1px solid #EAEAED"}}></div>
                      <div className="">Sub Category</div>
                  </div>
                </div>
            </div>
          </div>

          <div
            className="w-full flex px-10 py-4 justify-end items-center gap-4"
            style={{
              boxShadow: "0px -4px 40px 4px rgba(0,0,0,0.05)",
              backgroundColor: `${WHITE.W_100}`,
              // backgroundColor:"skyblue",
              position: "sticky",
              bottom: "0px",
            }}
          >

            <Button
              onClick={() => onSaveHandler()}
              disabled={category_levels === ""}
              loading={loading}
              sx={{
                height: "40px",
                width: "16.17%",
                backgroundColor: PRIMARY.P_BLue,
                padding: "8px 16px",
              }}
            >
              Save
            </Button>
          </div>
        </div>
      ) : (
        <div style={{ height: "calc(100vh - 72px)"}}>
          <div
            className="flex flex-row px-10"
            style={{
              height: 52,
              boxShadow: "0px 4px 10px 4px rgba(99, 99, 99, 0.05)",
            }}
          >

            {tabs.map((tab, i) => {
              if(category_hierarchy_level === 4) {
                return (
                  <div
                  onClick={() => onTabChange(tab.id, tab.url)}
                  key={tab.id}
                  className="p-4 cursor-pointer"
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: location.pathname === tab.url ? PRIMARY.P_BLue : BLACK.B_40,
                    borderBottom:
                      location.pathname === tab.url ? `2px solid ${PRIMARY.P_BLue}` : "",
                  }}
                >
                  {tab.name}
                </div>
              );
              }
              else if(category_hierarchy_level === 3) {
                return (
                  <>
                  {tab.id !== "PRINCIPAL_CATEGORY" && (<div
                  onClick={() => onTabChange(tab.id, tab.url)}
                  key={tab.id}
                  className="p-4 cursor-pointer"
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: location.pathname === tab.url ? PRIMARY.P_BLue : BLACK.B_40,
                    borderBottom:
                      location.pathname === tab.url ? `2px solid ${PRIMARY.P_BLue}` : "",
                  }}
                >
                  {tab.name}
                </div>)}
                </>
              );
              }
              else if(category_hierarchy_level === 2) {
                return (
                  <>
                  {tab.id !== "PRINCIPAL_CATEGORY" && tab.id !== "MAIN_CATEGORY" && (<div
                  onClick={() => onTabChange(tab.id, tab.url)}
                  key={tab.id}
                  className="p-4 cursor-pointer"
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: location.pathname === tab.url ? PRIMARY.P_BLue : BLACK.B_40,
                    borderBottom:
                      location.pathname === tab.url ? `2px solid ${PRIMARY.P_BLue}` : "",
                  }}
                >
                  {tab.name}
                </div>)}
                </>
              );
              }

            })}
          </div>
          <div
            className="pt-6 px-10"
            style={{ height: "calc(100vh - 125px)" }}
          >
            <Outlet />
          </div>
        </div>
  )}
    </>
  );
};

export default CategoryMasterManagement;